import base from './base.mixin' 
import ajax from '@/utils/ajax'
export default {
  //混入base,类似于继承
  mixins: [base],
  props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      //id
      id: 'id',
      //新增api
      addApi: '',
      //编辑api
      editApi: '',
      //findOne
      findOneApi: '',
      //新增请求形式
      addMethod: 'post',
      //编辑请求形式
      editMethod: 'post',
      //查询详情请求方式
      findOneMethod: 'post',
      //表单组件的默认名字
      editForm: 'editForm',
      //页面编辑数据
      editJson: {},
      //isSave
      isSave: false,
      //isEdit
      isEdit: false,
      //cache
      cacheEditJson: {},
      //规则
      rules: {},
      //loading
      loading: false,
      clearCache: false    
    }
  },
  watch: {
    //监听传入的信息，深拷贝新的数据，保证数据避免被污染
    editData:{
      handler:function(newValue){
        this.editJson = JSON.parse(JSON.stringify(newValue || {}))
        this.cacheEditJson = JSON.parse(JSON.stringify(this.editJson))
      },
      immediate: true
    }
  },
  mounted () {
    if(this.editJson[this.id]){
      this.isEdit = true
      this.loadDetail()
    }
  },
  methods: {
    //查询详情
    loadDetail(){
      if(this.editJson[this.id] && this.findOneApi){
        this.loading = true
        var params = {}
        params[this.id] = this.editJson[this.id]
        params = this.resetFindOneParams && this.resetFindOneParams(this.editJson) || params
        ajax[this.findOneMethod](this.findOneApi,params).then(response=>{
          this.loading = false
          this.editJson = this.filterDetailData && this.filterDetailData(response.data || response) || response.data
          this.cacheEditJson = JSON.parse(JSON.stringify(this.editJson))
          this.loadDetailSuccessHandler && this.loadDetailSuccessHandler()
        }).catch(()=>{ this.loading = false })
      }
    },
    //重置操作
    reset() {
      //清除表单验证结果
      this.$refs[this.editForm].clearValidate();
      //重置数据
      this.editJson = JSON.parse(JSON.stringify(this.editData));
    },
    //取消操作
    cancel() {
      if(JSON.stringify(this.editJson) != JSON.stringify(this.cacheEditJson) && !this.isSave){
        this.$confirm('当前信息有数据变动，你是否确定要关闭 ?','提示',{
          confirmButtonText: '继续编辑',
          cancelButtonText: '确认关闭',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
          type: 'warning'
        }).then(()=>{}).catch(()=>{
          //取消编辑弹窗
          this.$parent.$parent.hide();
        })
      }else{
        //取消编辑弹窗
        this.$parent.$parent.hide();
      }
    },
    //提交操作
    submit() {
      //验证表单校验是否通过
      this.$refs[this.editForm].validate(valid=>{
        //通过后提交数据
        if(valid){
          //判断是新增还是编辑操作
          var api = this.addApi;
          var apiMethod = this.addMethod;
          if(this.editJson[this.id]) {
            api = this.editApi;
            apiMethod = this.editMethod;
          }
          var params = this.resetSubmitParams && this.resetSubmitParams(this.editJson) || this.editJson;
          if(api)
            this.loading = true;
            //提交数据
            ajax[apiMethod](api,params).then(response=>{
              if(response.code == this.$config.ResultCode.SUCCESS_CODE || !response.error){
                this.loading = false;
                if (this.clearCache) {
                  this.$ajax.put(this.$api.sys.users.clearCache, {cacheKey :"PermissionCacheKey"}).then(() => {

                  });
                }
                //成功后回调
                this.$emit('submitSuccess');

                // 成功后需要执行的方法
                if (this._submitSuccessCallback) {
                  this._submitSuccessCallback();
                }

                //成功提示
                this.$message({
                  type: 'success',
                  message: this.successMsg || response.msg || this.$t('common.SubmitSuccess')
                });
                //标记是否已保存
                this.isSave = true;
                //取消弹窗
                this.cancel();
              }
            }).catch(()=>{ this.loading = false });
        }
      })
    }
  }
}